export { default as FlagOutlined } from './flag-outlined';
export { default as FlagSolid } from './flag-solid';
export { default as MinusOutlined } from './minus-outlined';
export { default as XMarkOutlined } from './x-mark-outlined';
export { default as EditPenOutlined } from './edit-pen-outlined';
export { default as EditPenSolid } from './edit-pen-solid';
